import { useEffect } from 'react';
import { useRouter } from 'next/router';

// React Hook 用于在组件中使用
export const useExternalSource = () => {
  const router = useRouter();

  useEffect(() => {
    if (router.isReady) {
      const params = router.query;
      if (params && params.tracking) {
        const source = params.tracking as string;
        //把 source 保存到 cookie 中，域名设置为跟域名
        document.cookie = `source=${source}; path=/; domain=${window.location.hostname}; SameSite=Lax`;
      }
    }
  }, [router.isReady, router.query]);
};
